import { type FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { BsFileEarmarkPlus, BsTrash } from 'react-icons/bs';
import { Draggable } from 'react-beautiful-dnd';

import { type RootState } from '@editor2/reducers/root';
import { deletePageFromPageGroup } from '@editor2/reducers/editor/editorSlice';
import { pageGroupPage } from '@editor2/containers/ChapterPage/styles';
import AddPageModal from '@editor2/components/AddPageModal';

interface Props {
	pageId: string;
	pageGroupId: string;
	chapterId: string;
	index: number;
	courseId: number;
}

const PageGroupPage: FC<Props> = (props) => {
	const { pageId, pageGroupId, chapterId, index, courseId } = props;

	const dispatch = useDispatch();
	const { pages, course } = useSelector((state: RootState) => state.courses[courseId]);
	const page = pages.entities[pageId];

	const [isAddPageModalShown, setAddPageModalShown] = useState(false);

	const onDeletePageClick = (pageId) => {
		if (window.confirm(`Are you sure to delete "${page.name}" page?`)) {
			dispatch(deletePageFromPageGroup({ pageGroupId, pageId, courseId }));
		}
	};

	return (
		<Draggable draggableId={pageId} index={index}>
			{(provided) => (
				<div
					className={pageGroupPage}
					ref={provided.innerRef}
					{...provided.draggableProps}
					{...provided.dragHandleProps}>
					<div className="pageMenu">
						<BsFileEarmarkPlus onClick={() => setAddPageModalShown(true)} />
						<BsTrash onClick={() => onDeletePageClick(pageId)} />
					</div>

					<Link
						to={`/courses/${course.id}/chapters/${chapterId}/page_groups/${pageGroupId}/pages/${pageId}`}>
						{page.name}
					</Link>

					{isAddPageModalShown && (
						<AddPageModal
							chapterId={chapterId}
							pageGroupId={pageGroupId}
							index={index + 1}
							onHide={() => setAddPageModalShown(false)}
							isShown={isAddPageModalShown}
							courseId={courseId}
						/>
					)}
				</div>
			)}
		</Draggable>
	);
};

export default PageGroupPage;
